import { render } from "./InvitationLinkModal.vue?vue&type=template&id=b12cf854"
import script from "./InvitationLinkModal.vue?vue&type=script&lang=js"
export * from "./InvitationLinkModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__